
import { T } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
//import * as ace from "ace-builds";
import * as ace from 'ace-builds/src-noconflict/ace';



interface JsonLine {
  lineNumber: number;
  content: string;
  indent: number;
  expandable: boolean;
  expanded: boolean;
  keyPath: string;
}

@Component({
  selector: 'json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss'],
  standalone: false
})
export class JsonViewerComponent implements AfterViewInit, OnChanges {
    
  
    ngOnChanges(changes: SimpleChanges): void {
       if (!this.isInitialized || !changes['json']) return;

        const newValue = changes['json'].currentValue;
        const currentValue = this.aceEditor.getSession().getValue();

        if (newValue !== currentValue) {
          if ( newValue != null ){
            this.aceEditor.getSession().setValue(newValue, -1); // avoids selection
          }
        }

    }
    
  
    @ViewChild('editor', { static: false }) editorRef!: ElementRef;
    @Output()jsonChange:EventEmitter<any> = new EventEmitter<any>();
    @Input() readOnly:boolean = true;
    @Input() startFold:boolean = true;
    @Input()maxLevelFold:number = 1;
    @Input() json: any = "{}";
    @Input() height="400px";
    aceEditor:any;
    isInitialized = false;
    ngAfterViewInit(): void {
        
         this.aceEditor = ace.edit(this.editorRef.nativeElement);
        
         ace.config.set('basePath', 'assets/ace');
         ace.config.setModuleUrl('ace/mode/json_worker', 'assets/ace/worker-json.js');
         ace.config.setModuleUrl('ace/theme/github', 'assets/ace/github.js');

         this.aceEditor.setTheme('ace/theme/github');
         this.aceEditor.session.setMode('ace/mode/json');
         this.aceEditor.session.setTabSize(2);
         this.aceEditor.session.setUseWrapMode(false);
         if ( this.json!=null ){
          this.aceEditor.session.setValue(this.json);
         }
         
         this.aceEditor.setOptions({
              fontSize: '14px',
              showPrintMargin: false,
              highlightActiveLine: true,
              showGutter: true,
              readOnly: this.readOnly
          });

          this.isInitialized = true;

          if ( this.startFold ){
            if ( this.maxLevelFold > 0){
              this.aceEditor.session.foldAll(1, this.aceEditor.session.getLength(), this.maxLevelFold);
            }else{
              this.aceEditor.execCommand("foldall");  
            }
          }

          if ( this.readOnly != null ){
            this.aceEditor.session.on('change', (delta) => {
              try {
                let newContent = this.aceEditor.session.getValue();
                const jsonObject = JSON.parse(newContent);
                this.jsonChange.emit(jsonObject);
              }catch(Exception){

              }
            });
          }
    }

    foldall(){

      if ( this.aceEditor != null ){
        this.aceEditor.execCommand("foldall");  
      }
    }

    unfoldall(){
      if ( this.aceEditor != null ){
        this.aceEditor.execCommand("unfoldall");  
      }
    }

    copy(){
        if ( this.aceEditor != null ){
          let value = this.aceEditor.session.getValue();
          this.copyToClipboard(value);
        }
    }

    public copyToClipboard(value) {
      const content = value;
      navigator.clipboard.writeText(content);
    }

    download(){
      if ( this.aceEditor != null ){
        let value = this.aceEditor.session.getValue();
        const blob = new Blob([value], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'data.json';
        a.click();
        URL.revokeObjectURL(url);
      }
    }
}